import { Ds } from "@accurx/design";
import { Feedback } from "@accurx/inbox-design-library";
import { useCurrentContactDetailSelection } from "domains/message-component/hooks/useCurrentContactDetailSelection";

export const AdditionalInformationInContactDetailFeedback = () => {
    const contactDetails = useCurrentContactDetailSelection();

    if (
        contactDetails.method === "None" ||
        !contactDetails.additionalInformation
    ) {
        return null;
    }

    return (
        <Feedback colour="information">
            <Ds.Text size="small" weight="regular" as="span" color="zinc">
                Extra details in medical record '
                {contactDetails.additionalInformation}'
            </Ds.Text>
        </Feedback>
    );
};
